<template lang="pug">
  .consultation--category.pt-6
    v-flex.xs12(v-for="k in Object.keys(firstFields)" :key="`first-${ k }`")
      h4.primary--text.mt-3.mb-3(v-if="k") {{ k }}

      .d-flex(v-for="field in firstFields[k]" :key="`field-row-${ field.id }`")
        v-flex.xs12(:class="k && 'pl-3'")
          field-row(:field="field" @update="(id, v) => $emit('update', id, v)")

          v-flex.group-add-row.xs12.pl-4.pt-1(v-if="field.grp && field.grp_add_text" :class="getIndentClass(field)")
            a.font-weight-bold(@click="$emit('add-group', field.id)") + {{ field.grp_add_text }}
            hr.mt-1(v-if="field.groups")

          v-flex.xs12(v-if="field.groups" :class="getIndentClass(field)")
            v-expansion-panels.flat-panels.ml-4(:value="getGroupPanelValue(field.groups)" flat tile multiple)
              v-expansion-panel.group-panel.mt-4(v-for="k_ in Object.keys(field.groups || {})" :key="k_" @change="onTogglePanel(k_)")
                v-expansion-panel-header {{ getGroupHeader(field.groups[k_]) }}
                v-expansion-panel-content(eager)
                  field-row(
                    v-for="field_ in field.groups[k_]"
                    :key="field_.id"
                    :field="field_"
                    @update="(id, v) => $emit('update', id, v)"
                  )

                  .group-remove-row.mt-2.pb-2
                    hr.mb-1
                    a.font-weight-bold(@click="$emit('del-group', field.id, k_)") - Entfernen

        v-flex.xs2.lg5.xl6.pt-10.pl-4(v-if="field.is_vv_nr && field.vv_ref_id")
          a(@click="$emit('open-field', field.vv_ref_id)") Zum Vertrag

    template(v-for="(building, index) in buildings_")
      v-flex.xs12.lg12.xl12(:key="building.id")
        h4.primary--text(:class="index > 0 && 'mt-5'") Gebäude „{{ building.name }}“

      v-flex.xs12.pl-3(v-for="k in Object.keys(building.fields)" :key="`${ building.id }-${ k }`")
        h4.primary--text.mt-3.mb-3(v-if="k") {{ k }}

        .d-flex(v-for="field in building.fields[k]" :key="`${ building.id }-${ field.id }`")
          v-flex.xs12(:class="k && 'pl-3'")
            field-row(:field="field" @update="(id, v) => $emit('update', id, v)")

            v-flex.group-add-row.xs12.pl-4.pt-1(v-if="field.grp && field.grp_add_text" :class="getIndentClass(field)")
              a.font-weight-bold(@click="$emit('add-group', field.id)") + {{ field.grp_add_text }}
              hr.mt-1(v-if="field.groups")

            v-flex.xs12(v-if="field.groups" :class="getIndentClass(field)")
              v-expansion-panels.flat-panels.ml-4(:value="getGroupPanelValue(field.groups)" flat tile multiple)
                v-expansion-panel.group-panel.mt-4(v-for="k_ in Object.keys(field.groups || {})" :key="k_")
                  v-expansion-panel-header {{ getGroupHeader(field.groups[k_]) }}
                  v-expansion-panel-content(eager)
                    field-row(
                      v-for="field_ in field.groups[k_]"
                      :key="field_.id"
                      :field="field_"
                      @update="(id, v) => $emit('update', id, v)"
                    )

                    .group-remove-row.mt-2.pb-2
                      hr.mb-1
                      a.font-weight-bold(@click="$emit('del-group', field.id, k_)") - Entfernen

          v-flex.xs2.lg5.xl6.pt-10.pl-4(v-if="field.is_vv_nr && field.vv_ref_id")
            a(@click="$emit('open-field', field.vv_ref_id)") Zum Vertrag

    v-flex.xs12(v-for="k in Object.keys(lastFields)" :key="`last-${ k }`")
      h4.primary--text.mt-3.mb-3(v-if="k") {{ k }}

      .d-flex(v-for="field in lastFields[k]" :key="`field-row-${ field.id }`")
        v-flex.xs12(:class="k && 'pl-3'")
          field-row(:field="field" @update="(id, v) => $emit('update', id, v)")

          v-flex.group-add-row.xs12.pl-4.pt-1(v-if="field.grp && field.grp_add_text" :class="getIndentClass(field)")
            a.font-weight-bold(@click="$emit('add-group', field.id)") + {{ field.grp_add_text }}
            hr.mt-1(v-if="field.groups")

          v-flex.xs12(v-if="field.groups" :class="getIndentClass(field)")
            v-expansion-panels.flat-panels.ml-4(:value="getGroupPanelValue(field.groups)" flat tile multiple)
              v-expansion-panel.group-panel.mt-4(v-for="k_ in Object.keys(field.groups || {})" :key="k_" @change="onTogglePanel(k_)")
                v-expansion-panel-header {{ getGroupHeader(field.groups[k_]) }}
                v-expansion-panel-content(eager)
                  field-row(
                    v-for="field_ in field.groups[k_]"
                    :key="field_.id"
                    :field="field_"
                    @update="(id, v) => $emit('update', id, v)"
                  )

                  .group-remove-row.mt-2.pb-2
                    hr.mb-1
                    a.font-weight-bold(@click="$emit('del-group', field.id, k_)") - Entfernen

        v-flex.xs2.lg5.xl6.pt-10.pl-4(v-if="field.is_vv_nr && field.vv_ref_id")
          a(@click="$emit('open-field', field.vv_ref_id)") Zum Vertrag

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ],

  components: {
    FieldRow: () => import('./field-row')
  },
})
export default class CategoryBasis extends Vue {
  @Prop({ type: Array, default: () => [] }) fields
  @Prop({ type: Object, default: () => {} }) buildings

  get firstFields () {
    const generalFields = this.fields
      .filter(f => !f.styling || f.styling.position !== 'last')

    return this.groupBySubSections(generalFields)
  }

  get lastFields () {
    const generalFields = this.fields
      .filter(f => f.styling && f.styling.position === 'last')

    return this.groupBySubSections(generalFields)
  }

  get buildings_ () {
    return Object.keys(this.buildings || {})
      .filter(k => !this.buildings[k].hidden)
      .map(k => ({
        id: this.buildings[k].id,
        name: this.buildings[k].name,
        fields: this.groupBySubSections(this.buildings[k].fields),
        sortIndex: this.buildings[k].sortIndex
      }))
      .sort((a, b) => a.sortIndex - b.sortIndex)
  }

  getIndentClass (field) {
    return field.styling && field.styling.indent
      ? 'pl-5'
      : ''
  }

  getGroupPanelValue (groups) {
    const panels = []

    Object.keys(groups)
      .forEach((k, i) => {
        if (this.openGroups.includes(k)) {
          panels.push(i)
        }
      })

    return panels
  }

  onTogglePanel (group) {
    let newValue = []
    if (this.openGroups.includes(group)) {
      newValue = [
        ...this.openGroups.filter(g => g !== group)
      ]
    } else {
      newValue = [
        ...this.openGroups,
        group
      ]
    }

    this.$store.dispatch('setOpenGroups', newValue)
  }

  getGroupHeader (fields) {
    if (!fields || !fields.length) {
      return ' '
    }

    return fields[0].value || ' '
  }

  groupBySubSections (fields) {
    const getAttachedFields = (fields_) => {
      const attachedFields = []
      return fields_
        .map((f, i) => {
          if (!f.styling) {
            return f
          }

          // f.styling = typeof f.styling === 'string'
          //   ? JSON.parse(f.styling)
          //   : f.styling

          if (f.styling.attach_next && fields_[i + 1]) {
            f.next_field = fields_[i + 1] || null
            attachedFields.push(fields_[i + 1].id)
          }
          return f
        })
        .filter(f => !f.hidden && !attachedFields.includes(f.id))
    }

    return getAttachedFields(fields)
      .map(f => {
        if (f.groups) {
          Object.keys(f.groups)
            .map(k => {
              f.groups[k] = getAttachedFields(f.groups[k])
            })
        }
        return f
      })
      .reduce((prev, cur) => {
        const key = cur.sub_section || ''
        prev[key] = prev[key] || []
        prev[key].push(cur)
        return prev
      }, {})
  }
}
</script>

<style lang="sass">
.group-add-row
  top: 202px
</style>
